import { fieldNameForKey, getFieldsValues, insertColor } from "../helper";
import { ComponentProps, MyStyles } from "../template.interface";

export default function TemplateCTA(props: ComponentProps) {
  const {
    id = "",
    styles = {},
    componentProps = {},
    content = {},
    wrapperProps = {},
    colors,
    values = {},
    fields = { static: {}, dynamic: {} },
    isEdit,
    tplVariantId,
  } = props;

  const { text } = getFieldsValues(content, values, fields, isEdit);
  // `cta_text` is measured too, so the CTA carries the same anchors as a text box.
  const tplField = fieldNameForKey(content?.text as string | undefined, fields);
  return (
    <div
      style={{
        ...(wrapperProps?.styles
          ? insertColor(wrapperProps.styles as MyStyles, values, fields, isEdit)
          : {}),
      }}
    >
      {/*
        An `<a>`, as served, styled with `generateHtml`'s `defaultButtonStyles` in the same order
        (defaults, then the template's own). No `href`: the preview is decorative and inert, and an
        `<a>` without one is not a link. The old `<button>` measured the same but carried a
        button's UA styles, so a DOM diff against the served ad never came out clean (parity D6).
      */}
      <a
        style={{
          background: "none",
          color: "inherit",
          border: "none",
          padding: 0,
          font: "inherit",
          cursor: "pointer",
          outline: "inherit",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          textDecoration: "none",
          ...insertColor(styles as MyStyles, values, fields, isEdit),
        }}
        {...componentProps}
        data-tpl-field={tplField}
        data-tpl-variant={tplVariantId}
      >
        {text}
      </a>
    </div>
  );
}
